var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseDropdown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.454,
    height: 20.454,
    viewBox: "0 0 20.454 20.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Vrstva_95",
    "data-name": "Vrstva 95",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_105",
    d: "M11.227 1a10.227 10.227 0 1 0 10.227 10.227A10.227 10.227 0 0 0 11.227 1zm0 18.594a8.367 8.367 0 1 1 8.367-8.367 8.367 8.367 0 0 1-8.367 8.367z",
    className: "prefix__cls-1",
    style: {
      fill: "#bfbfbf",
      fillRule: "evenodd"
    },
    "data-name": "Trazado 105",
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_106",
    d: "M16.357 11H6.8a.94.94 0 0 0 0 1.859h9.557a.94.94 0 0 0 0-1.859z",
    className: "prefix__cls-1",
    style: {
      fill: "#bfbfbf",
      fillRule: "evenodd"
    },
    "data-name": "Trazado 106",
    transform: "translate(-1.351 -1.703)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDropdown);
export default __webpack_public_path__ + "static/media/closeDropdown.e9a22a06.svg";
export { ForwardRef as ReactComponent };